/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Controller} from 'react-hook-form'
import _ from 'lodash'
import {
  VmoButton,
  VmoCheckbox,
  VmoForm,
  VmoFormDropdown,
  VmoFormField,
  VmoModal,
  VmoModalActions,
  VmoModalContent,
  VmoModalHeader,
  VmoNoData,
  VmoTable,
  VmoTableBody,
  VmoTableCell,
  VmoTableHeader,
  VmoTableHeaderCell,
  VmoTablePlaceholder,
  VmoTableRow,
  VmoTooltip,
} from 'vmo-library'

import {GET_CONTACT_LIST_ALL, GET_STATIC_CONTACT, GET_TAGS, GET_USERS, LIST_COMPANY_CONTACTS} from 'actions/types'
import {getStaticSegmentContactList} from 'actions/segment'
import {getTags, getUsers} from 'actions/settings'
import {getContactListAll, listCompaniesInContacts} from 'actions/contacts'
import useApiResponse from 'hooks/impure/useApiResponse'
import {get, getFormattedDate, getFullNameFromObj} from 'utils/helper'
import {countryList} from 'constants/variables'

const SegmentStep2 = props => {
  const {
    open,
    setOpen,
    CreateSegment,
    handleSubmit,
    reset,
    control,
    watch,
    setValue,
    step1Values,
    setFilter,
    filter,
    editId,
  } = props
  const dispatch = useDispatch()
  const watchedValues = watch()

  const [assigneeList, setAssigneeList] = useState([])
  const [tagList, setTagList] = useState([])
  const [companyList, setCompanyList] = useState([])
  const initialCurrentListofFilter = {
    assigneeId: '',
    tag: '',
    company: '',
    country: '',
    isFavourite: '',
  }
  const [contactList, setContactList] = useState([])

  const {successLabels = []} = useSelector(state => state.apiReducer)
  const {getContactListAllData = []} = useSelector(state => state.contacts)

  const {isLoading} = useApiResponse({
    label: GET_STATIC_CONTACT,
    onSuccess: data => {
      setContactList(data)
    },
    storePath: 'segment.getStaticSegmentData.contacts',
  })

  useApiResponse({
    action: getUsers,
    enabled: true,
    label: GET_USERS,
    storePath: 'settings.getUsersList',
    onSuccess: getUsersList => {
      const list = getUsersList?.users?.map(assignee => ({
        value: assignee.id,
        key: assignee.id,
        text: getFullNameFromObj(assignee),
      }))
      setAssigneeList(list || [])
    },
  })

  useApiResponse({
    action: getTags,
    enabled: true,
    label: GET_TAGS,
    storePath: 'settings.tagList',
    onSuccess: tagList => {
      const list = tagList?.map(({id, label}) => ({
        value: id,
        key: id,
        text: label,
      }))

      setTagList(list || [])
    },
  })

  useApiResponse({
    action: listCompaniesInContacts,
    enabled: true,
    label: LIST_COMPANY_CONTACTS,
    storePath: 'contacts.companyList',
    onSuccess: companyList => {
      const list = companyList?.map(company => ({
        value: company.id,
        key: company.id,
        text: company.name,
      }))

      setCompanyList(list || [])
    },
  })

  const step1 = step1Values()

  const applyFilterBtn = data => {
    const newData = _.pickBy(data.conditions, _.identity)

    if (!_.isEmpty(newData)) {
      setFilter(newData)
      setValue('ids', [])
    } else {
      setContactList(getContactListAllData)
    }
  }
  const handleCheck = id => {
    const isChecked = watchedValues.ids.some(lead => lead === id)

    if (isChecked) {
      const removeChecked = watchedValues.ids.filter(lead => lead !== id)
      setValue('ids', removeChecked)
    } else {
      setValue('ids', [...watchedValues.ids, id])
    }
  }

  const isChecked = id => {
    const check = watchedValues.ids.find(lead => lead === id)

    if (check) {
      return true
    }
    return false
  }

  const renderContactList = () => {
    return contactList.map((item, i) => (
      <VmoTableRow key={item.id} className="tableLink">
        {step1.isStatic && (
          <VmoTableCell key="checkbox" onClick={e => e.stopPropagation()}>
            <VmoTooltip
              content="Select"
              trigger={
                <VmoCheckbox
                  id={`${item.id}segment`}
                  className="d-inline-block"
                  onChange={() => handleCheck(item.id)}
                  checked={isChecked(item.id)}
                />
              }
            />
          </VmoTableCell>
        )}
        <VmoTableCell className="pl-4">{i + 1} </VmoTableCell>
        <VmoTableCell>{getFullNameFromObj(item).trim() || `#${item.id}`}</VmoTableCell>
        <VmoTableCell>{get(['email'], item, '')}</VmoTableCell>
        <VmoTableCell>{get(['status', 'status'], item, '')}</VmoTableCell>
        <VmoTableCell>{getFormattedDate(item.interactionTime)}</VmoTableCell>
      </VmoTableRow>
    ))
  }

  const isCheckedAll = () => {
    const allIds = (contactList || []).map(lead => lead.id)

    const checkAll = _.xor(allIds, watchedValues.ids).length === 0 && allIds.length !== 0
    if (checkAll) {
      return true
    }
    return false
  }

  const handleCheckAll = () => {
    const allIds = contactList.map(lead => lead.id)

    if (_.xor(allIds, watchedValues.ids).length === 0) {
      setValue('ids', [])
    } else setValue('ids', allIds)
  }

  const resetFilterBtn = () => {
    setFilter({})
    reset({ids: [], conditions: initialCurrentListofFilter})
    dispatch({type: 'CLEAR_STATIC_CONTACT'})
    setContactList(getContactListAllData)
  }

  useEffect(() => {
    const newData = _.pickBy(filter, _.identity)
    if (!_.isEmpty(newData)) {
      dispatch(getStaticSegmentContactList(props.type, newData))
    } else {
      dispatch({type: 'CLEAR_STATIC_CONTACT'})
    }
  }, [filter])

  useEffect(() => {
    dispatch(getContactListAll())
  }, [dispatch])

  useEffect(() => {
    if (successLabels.includes(GET_CONTACT_LIST_ALL)) {
      setContactList(getContactListAllData)
    }
  }, [successLabels])
  return (
    <VmoModal closeIcon onClose={() => setOpen(false)} open={open} size="large">
      <VmoModalHeader>Create List</VmoModalHeader>
      <VmoModalContent className="vmo-seg-wrap" scrolling>
        <div className="actBar">
          <h4 className="mb-3">Filter for Contact</h4>
          <VmoForm>
            <VmoFormField>
              <label>Assignee</label>
              <Controller
                control={control}
                name="conditions.assigneeId"
                render={({field: {value, onChange}}) => (
                  <VmoFormDropdown
                    placeholder="Assignee"
                    options={assigneeList}
                    fluid
                    search
                    clearable
                    selection
                    value={value}
                    onChange={(e, {value}) => onChange(value)}
                  />
                )}
              />
            </VmoFormField>
            <VmoFormField>
              <label>Tags</label>
              <Controller
                control={control}
                name="conditions.tag"
                render={({field: {value, onChange}}) => (
                  <VmoFormDropdown
                    placeholder="Tags"
                    options={tagList}
                    fluid
                    search
                    clearable
                    selection
                    value={value}
                    onChange={(e, {value}) => onChange(value)}
                  />
                )}
              />
            </VmoFormField>
            <VmoFormField>
              <label>Company</label>
              <Controller
                control={control}
                name="conditions.company"
                render={({field: {value, onChange}}) => (
                  <VmoFormDropdown
                    placeholder="Company"
                    options={companyList}
                    fluid
                    search
                    clearable
                    selection
                    value={value}
                    onChange={(e, {value}) => onChange(value)}
                  />
                )}
              />
            </VmoFormField>
            <VmoFormField>
              <label>Country</label>
              <Controller
                control={control}
                name="conditions.country"
                render={({field: {value, onChange}}) => (
                  <VmoFormDropdown
                    placeholder="Country"
                    options={countryList}
                    fluid
                    search
                    clearable
                    selection
                    value={value}
                    onChange={(e, {value}) => onChange(value)}
                  />
                )}
              />
            </VmoFormField>
            <VmoFormField>
              <label>Favourite</label>
              <Controller
                control={control}
                name="conditions.isFavourite"
                render={({field: {value, onChange}}) => (
                  <VmoFormDropdown
                    placeholder="Favourite"
                    options={[
                      {text: 'None', value: 'none', key: 'none'},
                      {
                        text: 'Favourite',
                        value: 'true',
                        key: 'favourite',
                      },
                      {
                        text: 'Unfavourite',
                        value: 'false',
                        key: 'unfavourite',
                      },
                    ]}
                    fluid
                    search
                    clearable
                    selection
                    value={value}
                    onChange={(e, {value}) => onChange(value)}
                  />
                )}
              />
            </VmoFormField>
          </VmoForm>

          <div className="d-flex mt-4">
            <VmoButton basic onClick={() => resetFilterBtn()}>
              Reset Filter
            </VmoButton>
            <VmoButton color="primary" onClick={handleSubmit(applyFilterBtn)}>
              Apply Filter
            </VmoButton>
          </div>
        </div>
        <div className="seg-list-body">
          <h4>Contacts ({contactList.length})</h4>
          <VmoTable basic>
            <VmoTableHeader>
              <VmoTableRow>
                {step1.isStatic && (
                  <VmoTableHeaderCell>
                    <VmoTooltip
                      content="Select All"
                      trigger={
                        <VmoCheckbox id="ckbSegment" label="" checked={isCheckedAll()} onChange={handleCheckAll} />
                      }
                    />
                  </VmoTableHeaderCell>
                )}
                <VmoTableHeaderCell className="pl-4">#</VmoTableHeaderCell>
                <VmoTableHeaderCell>Name</VmoTableHeaderCell>
                <VmoTableHeaderCell>Emails</VmoTableHeaderCell>
                <VmoTableHeaderCell>Status</VmoTableHeaderCell>
                <VmoTableHeaderCell>Last Interaction time</VmoTableHeaderCell>
              </VmoTableRow>
            </VmoTableHeader>
            <VmoTableBody>
              {isLoading ? (
                <VmoTablePlaceholder columns={5} rows={6} />
              ) : (contactList || []).length > 0 ? (
                renderContactList()
              ) : (
                <VmoTableRow>
                  <VmoTableCell className="emptyValue" colSpan={6}>
                    <VmoNoData type="table" noDataText="No Data Available" />
                  </VmoTableCell>
                </VmoTableRow>
              )}
            </VmoTableBody>
          </VmoTable>
        </div>
      </VmoModalContent>
      <VmoModalActions>
        <VmoButton onClick={() => setOpen('step1')} basic>
          Back
        </VmoButton>
        <VmoButton content={editId ? 'Update' : 'Create'} onClick={handleSubmit(CreateSegment)} primary />
      </VmoModalActions>
    </VmoModal>
  )
}

export default SegmentStep2
